module.exports = __webpack_public_path__ + "static/how-to-win-friends-and-influence-people-18b68c9eb2e7717b1f8315e4b07a2d25.jpg";